import { render } from "./RegisterLayout.vue?vue&type=template&id=e3f85ad0&scoped=true"
import script from "./RegisterLayout.vue?vue&type=script&lang=js"
export * from "./RegisterLayout.vue?vue&type=script&lang=js"

import "./RegisterLayout.vue?vue&type=style&index=0&id=e3f85ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f85ad0"]])

export default __exports__